const defaultPageSize = 25;
const apiQueryParams = {
    limit: defaultPageSize,
    offset: 0,
    sort: "",
    search: "",
    filters: []
};

const colors = {
    primary: "#8231d3",
    secondary: "#5840FF",
    success: "#01B81A",
    info: "#00AAFF",
    warning: "#FA8B0C",
    danger: "#ff0f0f",
    dark: "#0A0A0A",
    body: "#5e6278",
    white: "#fff",
    light: "#8C90A4",
    gray: "#8C90A4"
};

export {
    apiQueryParams,
    colors,
    defaultPageSize
}